import { a as _objectSpread2 } from '../../_rollupPluginBabelHelpers-3b7bd988.js';
import { inRange, lt, gt } from 'date-arithmetic';
import { uuidv4 } from './dataHelpers.js';

const createEvent = (startDate, endDate, id) => ({
  startDate,
  endDate,
  id: id || uuidv4()
});
const createDayEventsCopy = (dayEvents, targetDateDaysOffset) => {
  return dayEvents.map(event => {
    const newDayEvent = _objectSpread2(_objectSpread2({}, event), {}, {
      startDate: new Date(event.startDate.getTime()),
      endDate: new Date(event.endDate.getTime())
    });
    newDayEvent.id = uuidv4();
    newDayEvent.startDate.setDate(newDayEvent.startDate.getDate() + targetDateDaysOffset);
    newDayEvent.endDate.setDate(newDayEvent.endDate.getDate() + targetDateDaysOffset);
    return newDayEvent;
  });
};
const getTargetDateDaysOffset = (dayNumber, currentDayOfTheWeek, firstDayOfWeek) => {
  if (firstDayOfWeek === 0) {
    return dayNumber - currentDayOfTheWeek;
  }
  return currentDayOfTheWeek === 0 ? (7 - dayNumber) * -1 : dayNumber === 0 ? 7 - currentDayOfTheWeek : dayNumber - currentDayOfTheWeek;
};
const getDayEvents = (date, events) => {
  const dayEvents = events.filter(event => inRange(date, event.startDate, event.endDate, ''));
  if (dayEvents.length > 1) {
    dayEvents.sort((a, b) => a.startDate.getTime() - b.startDate.getTime());
  }
  return dayEvents;
};
const isDateInEventRange = (currentDate, event) => {
  return inRange(currentDate, event.startDate, event.endDate, 'Minutes');
};
const isCurrentDateLess = (currentDate, desiredDate) => {
  return lt(currentDate, desiredDate, 'Minutes');
};
const isCurrentDateGreater = (currentDate, desiredDate) => {
  return gt(currentDate, desiredDate, 'Minutes');
};

export { createDayEventsCopy, createEvent, getDayEvents, getTargetDateDaysOffset, isCurrentDateGreater, isCurrentDateLess, isDateInEventRange };
